import { useLearningUiTranslation } from '@features/learning/shared/use-learning-ui-translation'
import { Gamepad2, Lock, Sparkles, Trophy } from 'lucide-react'
import { AppDialog, LmsButton } from '@shared/ui'
import './flashcard-game.css'

export function FlashcardGameLauncher({
  canUsePremiumLevel,
  onClose,
  onStart,
  open,
  selectedCount,
}: {
  readonly canUsePremiumLevel: boolean
  readonly onClose: () => void
  readonly onStart: (level: 'basic' | 'advanced' | 'pro') => void
  readonly open: boolean
  readonly selectedCount: number
}) {
  const ui = useLearningUiTranslation()
  return (
    <AppDialog
      description={ui("If you selected cards manually, keep either one card or at least twelve cards to match the legacy game-entry rule.")}
      onClose={onClose}
      open={open}
      title={ui("Flashcard game levels")}
    >
      <div className="flashcardGameLauncher">
        {selectedCount > 1 && selectedCount < 12 ? (
          <p className="flashcardGameAlert" data-tone="warning" role="alert">
            {ui("The current selection is too small for legacy gameplay. Add more selected cards or clear the collection to use the whole category.")}</p>
        ) : null}

        <LmsButton
          fullWidth
          leadingIcon={<Gamepad2 aria-hidden="true" className="size-4" />}
          onClick={() => {
            onStart('basic')
          }}
          variant="primary"
        >
          {ui("Basic")}</LmsButton>
        <LmsButton
          disabled={!canUsePremiumLevel}
          fullWidth
          leadingIcon={
            canUsePremiumLevel ? (
              <Sparkles aria-hidden="true" className="size-4" />
            ) : (
              <Lock aria-hidden="true" className="size-4" />
            )
          }
          onClick={() => {
            onStart('advanced')
          }}
          variant="outline"
        >
          {ui("Advanced")}</LmsButton>
        <LmsButton
          disabled={!canUsePremiumLevel}
          fullWidth
          leadingIcon={
            canUsePremiumLevel ? (
              <Trophy aria-hidden="true" className="size-4" />
            ) : (
              <Lock aria-hidden="true" className="size-4" />
            )
          }
          onClick={() => {
            onStart('pro')
          }}
          variant="outline"
        >
          {ui("Pro")}</LmsButton>
      </div>
    </AppDialog>
  )
}
